import { render, staticRenderFns } from "./MelosPlayerController.vue?vue&type=template&id=0b7c6d7c&"
import script from "./MelosPlayerController.vue?vue&type=script&lang=ts&"
export * from "./MelosPlayerController.vue?vue&type=script&lang=ts&"
import style0 from "./MelosPlayerController.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports